<script>
    import { getProgramPageContent } from '../../firebase/getProgramPageContent.js'
</script>


    <h1 class="header_text" style="margin-bottom: 20px; margin-top: 20px">
        NIKECRAFT WEAR TESTERS
    </h1>
    
    <iframe title="homepage_video" width="345" height="520" style="max-width: 100%;" src={'https://www.youtube.com/embed/1dBZRO8IcQo'} frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>    

